<template>
  <nut-popup
    :duration="0.01"
    @close="close()"
    :style="{ backgroundColor: 'rgba(255, 255, 255, 0)' }"
    teleport="#app"
    position="bottom"
    v-model:visible="state.shareCardShow"
  >
    <!-- 合成的卡片 -->
    <div
      style="
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 26px;
      "
    >
      <img
        :src="state?.imgUrl"
        mode="widthFix"
        style="width: 236px; border-radius: 16px"
      />
    </div>
    <div class="box">
      <div class="title">
        <div></div>
        <div>分享到</div>
        <!-- <div > -->
        <img
          :src="require('@/assets/image/Close.png')"
          mode=""
          style="width: 12px; height: 12px"
          @click="shareFun()"
        />
        <!-- </div> -->
      </div>
      <div class="btnBox">
        <div
          v-for="(item, index) in state.items"
          :key="item.name"
          @click.stop="shareFun(item, index)"
        >
          <img :src="item.src" style="width: 60px; height: 60px" />
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
  </nut-popup>
</template>
<script>
import { reactive, toRefs, watchEffect, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { getShareInfoImg } from "@/api/examination(22524)";
export default {
  name: "shareCard",
  props: {
    shareCardShow: {
      type: Boolean,
      default: false,
      required: true,
    },
    detailData: {
      required: true,
      default: null,
    },
    // 首页还是详情页
    type: {
      require: true,
      default: 1,
    },
    // 分享标题
    titleVal: {
      require: true,
      default: null,
    },
  },
  setup(props, con) {
    const store = useStore();
    const { shareCardShow, detailData, type, titleVal } = toRefs(props);
    const state = reactive({
      shareCardShow: shareCardShow.value,
      detailData: detailData.value,
      type: type.value,
      titleVal: titleVal.value,
      imgUrl: "",
      items: [
        {
          src: require("@/assets/image/shareWc.png"),
          name: "微信",
          scene: "WXSceneSession",
        },
        {
          src: require("@/assets/image/shareWcp.png"),
          name: "朋友圈",
          scene: "WXSenceTimeline",
        },
        {
          src: require("@/assets/image/savePoster.png"),
          name: "保存海报",
          scene: "",
        },
      ],
    });
    watchEffect(() => {
      const { shareCardShow, detailData, type, titleVal } = toRefs(props);
      state.shareCardShow = shareCardShow.value;
      state.detailData = detailData.value;
      state.type = type.value;
      state.titleVal = titleVal.value;
      if (state.detailData != null) {
        getShareInfoImgFun();
      }
    });
    // 获取分享海报
    const getShareInfoImgFun = async () => {
      const res = await getShareInfoImg({
        userActivityId: state.detailData.id,
      });
      if (res.code == 200) {
        state.imgUrl = res.data;
      }
    };
    return {
      state,
      getShareInfoImgFun,
      store,
    };
  },
  emits: ["close"],
  mounted() {
    let that = this;
    this.$nextTick(() => {
      // 初始化uni.webview
      document.addEventListener("UniAppJSBridgeReady", function () {});
    });
  },
  methods: {
    close() {
      this.$emit("close", false);
    },
    shareFun(item, index) {
      let data = {
        type: 0, //教程还是随拍
        shareNum: 0, //分享到哪里，0微信好友、1朋友圈、3保存海报
        shareType: 0, // 分享的类型，同uni.share 0图文、1纯文字、2纯图片
        href: "",
        title: "",
        summary: "", //描述
        imageUrl: "",
      };
      if (index == 0) {
        const hj = store.state.huanj == 0? "/testvote": "/vote"
        data.shareNum = 0;
        data.shareType = 0;
        data.title = this.state.titleVal;
        data.href =
          window.location.origin + window.location.pathname +
              "#/examination/examinationDetail?id=" +
              this.state.detailData.id;
        data.summary = "就差你一票了，我正在参加水灵子舞蹈考核";
        data.imageUrl =
          this.state.type == 1
            ? this.state.detailData.coverPlan
            : this.state.detailData.shareImg; //详情页取分享图片
      } else if (index == 1) {
         const hj = store.state.huanj == 0? "/testvote": "/vote"
        data.shareNum = 1;
        data.shareType = 0;
        data.title = this.state.titleVal;
        data.href =
          window.location.origin + window.location.pathname +
              "#/examination/examinationDetail?id=" +
              this.state.detailData.id;
        data.summary = "就差你一票了，我正在参加水灵子舞蹈考核";
        data.imageUrl =
          this.state.type == 1
            ? this.state.detailData.coverPlan
            : this.state.detailData.shareImg;
      } else {
        // 保存海报，只传类型，和图片地址
        data.shareNum = 2;
        data.imageUrl = this.state.imgUrl;
        // var image = new Image();
        // // 解决跨域 Canvas 污染问题
        // image.setAttribute("crossOrigin", "anonymous");
        // image.onload = function () {
        //   var canvas = document.createElement("canvas");
        //   canvas.width = image.width;
        //   canvas.height = image.height;
        //   var context = canvas.getContext("2d");
        //   context.drawImage(image, 0, 0, image.width, image.height);
        //   var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
        //   var a = document.createElement("a"); // 生成一个a元素
        //   var event = new MouseEvent("click"); // 创建一个单击事件
        //   a.download = "examinationImg_poster"; // 设置图片名称
        //   a.href = url; // 将生成的URL设置为a.href属性
        //   a.dispatchEvent(event); // 触发a的单击事件
        // };
        // image.src = data.imageUrl;
        // return false;
      }
      this.close();
      uni.postMessage({
        data,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  background-color: #ffffff;
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  padding: 18px 15px 0 15px;
  box-sizing: border-box;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #2b3236;
    font-size: 18px;
    font-family: "Alibaba PuHuiTi 2.0 85 Bold";
    font-weight: bold;
  }
}

.btnBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 47px;
  padding-bottom: 40px;

  > div {
    flex: 5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: "Alibaba PuHuiTi 2.0 55 Regular";
    color: #2b3236;
    font-size: 16px;

    image {
      margin-bottom: 12px;
    }
  }
}
</style>
